/**
 * Vercel Preview-only runtime/build knobs.
 * See SUNSET.md when removing Preview hosting.
 */

const VERCEL_CSP_CONNECT_SOURCES = ['https://vitals.vercel-insights.com'];

const VERCEL_CSP_SCRIPT_SOURCES = [
  'https://vercel.live',
  'https://va.vercel-scripts.com/v1/script.debug.js',
];

function isVercelRuntime() {
  return Boolean(process.env.VERCEL);
}

function isVercelClient() {
  return Boolean(process.env.NEXT_PUBLIC_VERCEL_ENV);
}

function isEtsNext() {
  return (
    process.env.NEXT_PUBLIC_ETSNEXT_OVERLOAD === 'true' ||
    ['etsNext', 'etsNextSit'].includes(process.env.ENVIRONMENT)
  );
}

function getNextOutput() {
  if (isVercelRuntime()) {
    return undefined;
  }
  return 'standalone';
}

function getDeploymentCachePrefix() {
  return process.env.VERCEL_DEPLOYMENT_ID;
}

function shouldEnableVercelAnalytics() {
  return isVercelClient() && !isEtsNext();
}

function getVercelCspConnectSources() {
  if (!isVercelRuntime()) {
    return [];
  }
  return VERCEL_CSP_CONNECT_SOURCES.slice();
}

function getVercelCspScriptSources() {
  if (!isVercelRuntime()) {
    return [];
  }
  return VERCEL_CSP_SCRIPT_SOURCES.slice();
}

module.exports = {
  isVercelRuntime,
  isVercelClient,
  getNextOutput,
  getDeploymentCachePrefix,
  shouldEnableVercelAnalytics,
  getVercelCspConnectSources,
  getVercelCspScriptSources,
};
